export default "__VITE_ASSET__6bc549f5__"